<template>
  <div class="common-home-content" v-show="show">
    <van-search 
      class="search-input" 
      v-model="keyword" 
      placeholder="输入疾病"
      @search="onSearch"
    />
    <van-list
      v-model="loading"
      :finished="finished"
      @load="getDate(false)"
      v-if="result_count > 0"
    >
      <p class="result-num"><span class="icon">找到<span class="color">{{result_count}}</span>条结果</span></p>
      <ul class="cases-ul">
        <li
          v-for="(child, index) in cases"
          :key="index"
          @click="toDetail(child)"
        >
          <p class="title"><span v-html="child.disease"></span> | <span v-html="child.doctor"></span></p>
          <p class="symptom"><span class="color">【证候表现】</span><span v-html="child.symptom"></span></p>
          <p class="provenace"><span class="color">【出处】</span><span v-html="child.provenace"></span></p>
          <span class="gengd-icon"></span>
        </li>
      </ul>
      <p class="no-more" v-if="total_pages > 1 && finished">没有更多了</p>
    </van-list>
    <div class="not-cases" v-else>
      <img src="../../assets/images/address/tip.png" alt="">
      <p class="title">抱歉，暂时没有搜索到您想要的~</p>
    </div>
  </div>
</template>
<script>
import http from '../../util/iapetusApiConfig'
export default {
  data() {
    return {
      show: false,
      loading: false,
      finished: false,
      token: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiMSIsImV4cF90aW1lIjoxNTk5MTIyNjE5fQ.nraNftJVGDgVlKTYF5Sa6aMm4j4MBZywLXASSmZrpdU',
      doctor_id: 1,
      keyword: '',
      result_count: 0,
      current_page: 0,
      page_size: 10,
      total_pages: 1,
      cases: []
    };
  },
  created() {
    if(this.$route.query.keyword){
      this.keyword = this.replaceIllegalStr(this.$route.query.keyword);
    }
    if(localStorage.getItem('case_keyword')){
      this.keyword = localStorage.getItem('case_keyword');
      localStorage.removeItem('case_keyword');
    }
    var user_info = this.$appUtils.appData();
    if(user_info){
        this.doctor_id = user_info.doctor_id;
        this.token = user_info.token;
    }
    this.getDate(true);
    window.appBack = ()=> this.pageback();
  },
  methods: {
    replaceIllegalStr(s){
      var pattern = new RegExp("^[A-Za-z0-9\u4e00-\u9fa5《》□ ⅠⅡ Ⅲ Ⅳ Ⅴ Ⅵ Ⅶ Ⅷ Ⅸ Ⅹ]+$");
      var rs = ""; 
      var s_trin = s;
      for (var i = 0; i < s_trin.length; i++) { 
          if(pattern.test(s_trin[i])){
              rs = rs+s_trin[i];
          }else{
          rs = rs+' '; 
          }
      }
      return rs.replace(/\s{2,}/g," ");
    },
    getDate(clear) {
      let that = this;
      if(clear){
        that.current_page = 0;
      }
      let params = {
          page: that.current_page + 1,
          page_size: that.page_size
      }
      if(that.keyword){
        params['keywords'] = that.keyword;
      }
      http.get("/studio/medical_cases", {params: params,
        headers: {
            "Authorization": that.token
        }
      }).then(function(res) {
          if(res.data.status_code == 200){
            if(clear){
              that.cases = [];
            }
            that.cases = that.cases.concat(res.data.data.items);
            that.result_count = parseInt(res.data.data.result_count);
            that.current_page = parseInt(res.data.data.page);
            that.total_pages = parseInt(res.data.data.total_pages);
            if(that.current_page >= that.total_pages){
              that.finished = true;
            }else{
              that.finished = false;
            }
          }
          that.loading = false;
          that.show = true;
          that.$appUtils.appCloseLoadingView();
      });
    },
    onSearch() {
      this.getDate(true);
    },
    toDetail(item){
      localStorage.setItem("case_keyword", this.keyword);
      this.$router.push({ path: "/andetail/"+item['id'], query: {providerInfo: this.$route.query.providerInfo}});
    },
    pageback(){
      return null;
    }  
  },
};
</script>
<style lang="scss" scoped>
.common-home-content{
  padding-bottom: 10px;
}
.common-home-content-pt{
  padding-top: 50px;
}
.header-right-btn{
  height: 16px;
  line-height: 16px;
  font-size:16px;
  font-family:PingFang SC;
  font-weight:bold;
  color:rgba(172,76,56,1);
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 15px;
}
.search-input{
  width: 100%;
  height: 36px;
  padding: 0 15px;
  font-size: 14px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #333333;
  .van-search__content{
    padding-left: 0;
    background: #F4F4F4;
    border-radius: 17px;
    .van-field{
      border: 0;
      box-shadow: none;
    }
  }
}
.result-num{
  margin-top: 23px;
  line-height: 12px;
  font-size: 12px;
  font-family: PingFang-SC-Medium;
  font-weight: 500;
  color: #999999;
  text-align: center;
  .icon{
    display: inline-block;
    position: relative;
    .color{
      color: #AC4B38;
    }
  }
  .icon::before{
    content: '';
    display: block;
    width: 116px;
    height: 1px;
    border-bottom: 1px dashed #cccccc;
    margin: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: -122px;
  }
  .icon::after{
    content: '';
    display: block;
    width: 116px;
    height: 1px;
    border-bottom: 1px dashed #cccccc;
    margin: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    right: -122px;
  }
}
.cases-ul{
  width: 100%;
  box-sizing: border-box;
  & > li{
    margin-bottom: 10px;
    width: 100%;
    padding: 28px 15px 28px;
    box-sizing: border-box;
    border-bottom: 2px solid #e6e6e6;
    position: relative;
    .title{
      line-height: 16px;
      font-size: 16px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #333333;
      display: inline-block;
      white-space: nowrap; 
      width: 100%; 
      overflow: hidden;
      text-overflow:ellipsis;
    }
    .symptom,
    .provenace{
      box-sizing: border-box;
      padding-right: 10px;
      margin-top: 12px;
      line-height: 14px;
      font-size: 14px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #333333;
      display: inline-block;
      white-space: nowrap; 
      width: 100%; 
      overflow: hidden;
      text-overflow:ellipsis;
      .color{
        color: #999999;
      }
    }
    .gengd-icon{
        display: block;
        width: 6px;
        height: 10px;
        background: url('../../assets/images/survey/gengd.png') no-repeat;
        background: none\9;
        background-size: 6px 10px;
        margin: auto;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 15px;
    }
  }
}
.no-more{
  color: #969799;
  font-size: 14px;
  line-height: 50px;
  text-align: center;
}
.not-cases{
  margin-top: 182px;
  width: 100%;
  display: inline-block;
  text-align: center;
  img{
    width: 118px;
  }
  .title{
    margin-top: 17px;
    line-height: 16px;
    font-size:16px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    color:rgba(154,154,154,1);
  }
}
</style>
<style>
.search-input .van-field__left-icon{
    margin-left: 13px;
    margin-right: 13px;
  }
  .cases-ul li em{
    color: #AC4B38;
  }
</style>


// WEBPACK FOOTER //
// src/components/doctor/anlist.vue